/** The budget-pause dialog (BENCH-UX-SPEC §2): the guard paused at 1.5× the confirmed estimate. */
import { fmt2 } from '../format.ts';
import { BUDGET } from '../strings-bench.ts';
import { Dialog } from '../ui.tsx';
import { continueLimit, resumeBudget, stopPausedJob } from './controller.ts';
import { budgetDialogOpen, budgetState } from './state.ts';

export function BudgetDialog() {
	const s = budgetState.value;
	if (!s) return null;
	return (
		<Dialog
			title={BUDGET.dialogTitle}
			open={budgetDialogOpen.value}
			onClose={stopPausedJob}
			actions={
				<>
					<button type="button" class="btn btn-secondary" onClick={stopPausedJob}>
						{BUDGET.stop}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						onClick={() => resumeBudget(continueLimit(s.limitUsd))}
					>
						{BUDGET.continueLabel}
					</button>
				</>
			}
		>
			<p>{BUDGET.body(fmt2(s.spentUsd), fmt2(s.limitUsd))}</p>
			<p class="dim">{BUDGET.continueNote}</p>
		</Dialog>
	);
}
